import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";
import { colors, fonts, header } from "../../../styles/variables";
import { safeAreaAbsoluteTop } from "../../../styles/safeArea";

import Title from "../../atoms/Title";
import {
  InfoBoxItem,
  InfoBoxItemDescriptionHolder,
  InfoBoxItemProductHolder,
  InfoBoxItemProductHolderButtons,
} from "../../atoms/SpecialInfoBoxItem";

export const MainTitle = styled(Title)`
  margin-bottom: 50px;
`;

export const StyledInfoBoxItem = styled(InfoBoxItem)`
  align-items: flex-start;
  ${(props) => props.css}
`;

export const StyledInfoBoxItemProductHolderButtons = styled(InfoBoxItemProductHolderButtons)`
  position: relative;
  ${breakpoints.smUp} {
    position: sticky;
    left: 0;
    bottom: 0;
  }
  ${(props) => props.css}
`;

export const StyledInfoBoxItemDescriptionHolder = styled(InfoBoxItemDescriptionHolder)`
  width: 100% !important;
  ${(props) => props.css}
`;

export const StyledInfoBoxItemProductHolder = styled(InfoBoxItemProductHolder)`
  ${breakpoints.smUp} {
    position: sticky;
    left: 0;
    top: ${header.mobileHeight};
  }
  ${breakpoints.lgUp} {
    top: ${header.desktopHeight};
  }
  ${(props) => props.css}
`;

export const InfoBoxItemDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  ${breakpoints.smUp} {
    width: 50%;
    flex-shrink: 0;
  }
  ${breakpoints.smDown} {
    margin-bottom: 150px;
  }

  ${(props) => props.css}
`;

export const StyledDescription = styled.p`
  white-space: pre-line;
`;

export const CloseTrayButton = styled.div`
  background-color: white;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 25px;
  position: absolute;
  ${safeAreaAbsoluteTop(20)}
  left: 20px;
  width: 40px;
  height: 40px;
  z-index: 1;
  > img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;

export const StyledContentLink = styled.a`
  display: inline-block;
  color: ${colors.black};
  font-family: ${fonts.fontBauMedium};
  &:hover,
  &:focus {
    color: ${colors.black};
  }
`;
